import React from 'react';
import { connect } from 'react-redux'
import './style.css';
import { connectorActiveImgs } from '../connectors';
import { COLOR_PRIMARY } from '../../../utils/settings';

import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Card from '@material-ui/core/Card';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import PhoneIcon from '@material-ui/icons/Phone';
import WatchLaterIcon from '@material-ui/icons/WatchLater';
import HomeIcon from '@material-ui/icons/Home';
import PaymentIcon from '@material-ui/icons/Payment';
import ChatIcon from '@material-ui/icons/Chat';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Box from '@material-ui/core/Box';
import { formatDistance } from 'date-fns'
import { de } from 'date-fns/locale'
import { EmojiTransportation } from '@material-ui/icons';

const COLOR_FREE = COLOR_PRIMARY;
const COLOR_OCCUPIED = '#666666';
const COLOR_FAILURE = '#cc2222';
const COLOR_RESERVED = '#9949c2';

function DetailDrawer({ open, toggleDetailsDrawer, station, loadingStation }) {
    return (
        <Drawer
            anchor='right'
            open={open}
            onClose={toggleDetailsDrawer('right', false)}
            PaperProps={{ style: { position: 'absolute' } }}
            BackdropProps={{ style: { position: 'absolute' } }}
            ModalProps={{
                container: document.getElementById('finder-container'),
                style: { position: 'absolute' }
            }}
            variant="temporary"
        >
            <div className={'details'}>
                {loadingStation ?
                    <div className={'loader'}>
                        <CircularProgress />
                        <Typography className={'wait'}>Daten werden geladen</Typography>
                    </div>
                    : null}
                {station ?
                    <div className={'station'}>
                        <AppBar position="sticky">
                            <Toolbar>
                                <Typography noWrap variant="h6" color="inherit">
                                    <b>{station.label}</b>
                                </Typography>
                            </Toolbar>
                        </AppBar>
                        <div className={'operator'}>
                            <List subheader={<ListSubheader disableSticky>Betreiber</ListSubheader>}>
                                <ListItem divider key={'operator'}>
                                    <ListItemIcon>
                                        <EmojiTransportation />
                                    </ListItemIcon>
                                    <ListItemText>
                                        {station.operator.name}
                                    </ListItemText>
                                </ListItem>
                            </List>
                        </div>
                        <div className={'general'}>
                            <List subheader={<ListSubheader disableSticky>Allgemeine Informationen</ListSubheader>}>
                                <ListItem divider key={'address'}>
                                    <ListItemIcon>
                                        <HomeIcon />
                                    </ListItemIcon>
                                    <ListItemText>
                                        {station.address_street}<br />{station.address_country ? station.address_country + '-' : null}{station.address_zip} {station.address_city}
                                    </ListItemText>
                                </ListItem>
                                {station.marketing.hotline ? <ListItem divider key={'phone'}>
                                    <ListItemIcon>
                                        <PhoneIcon />
                                    </ListItemIcon>
                                    <ListItemText>
                                        {station.marketing.hotline}
                                    </ListItemText>
                                </ListItem> : null}
                                {station.marketing.opening_times ? <ListItem divider key={'opening'}>
                                    <ListItemIcon>
                                        <WatchLaterIcon />
                                    </ListItemIcon>
                                    <ListItemText>
                                        {station.marketing.opening_times}
                                    </ListItemText>
                                </ListItem> : null}
                                {station.marketing.payment ? <ListItem divider key={'payment'}>
                                    <ListItemIcon>
                                        <PaymentIcon />
                                    </ListItemIcon>
                                    <ListItemText>
                                        {station.marketing.payment}
                                    </ListItemText>
                                </ListItem> : null}
                                {station.marketing.additional ? <ListItem divider key={'comment'}>
                                    <ListItemIcon>
                                        <ChatIcon />
                                    </ListItemIcon>
                                    <ListItemText>
                                        {station.marketing.additional}
                                    </ListItemText>
                                </ListItem> : null}
                            </List>
                        </div>
                        <div className={'plugs'}>
                            <List subheader={<ListSubheader disableSticky>Ladepunkte ({station.connectors.length})</ListSubheader>}>
                                {station.connectors.length > 0 ? station.connectors.map((plug, i) => {
                                    return (
                                        <Box mb={2} ml={2} mr={2} key={'box-' + i}>
                                            <Card>
                                                <React.Fragment key={'frag-' + i}>
                                                    <ListItem style={{ backgroundColor: renderStatusColor(plug.status, station.additional ? station.additional.group : null) }} key={i + '-label'}>
                                                        <ListItemText style={{ color: '#ffffff' }}>
                                                            <b>{plug.evseid ? plug.evseid : plug.label}</b>
                                                        </ListItemText>
                                                        <ListItemSecondaryAction>
                                                            <img alt={'plug'} src={connectorActiveImgs[plug.type.icon]} style={{ width: '40px', height: 'auto' }} />
                                                        </ListItemSecondaryAction>
                                                    </ListItem>
                                                    <ListItem key={i + '-status'}>
                                                        <ListItemText>
                                                            <b>Status</b>
                                                        </ListItemText>
                                                        <ListItemSecondaryAction>
                                                            {renderStatus(plug.status)}
                                                        </ListItemSecondaryAction>
                                                    </ListItem>
                                                    {plug.occupied_since && (
                                                        <ListItem key={i + '-occupiedsince'}>
                                                            <ListItemText>
                                                                <b>Belegt seit</b>
                                                            </ListItemText>
                                                            <ListItemSecondaryAction>
                                                                {formatDistance(Date.parse(plug.occupied_since), new Date(), { locale: de })}
                                                            </ListItemSecondaryAction>
                                                        </ListItem>
                                                    )}
                                                    <ListItem key={i + '-plug'}>
                                                        <ListItemText>
                                                            <b>Steckertyp</b>
                                                        </ListItemText>
                                                        <ListItemSecondaryAction>
                                                            {plug.type.plug_type}
                                                        </ListItemSecondaryAction>
                                                    </ListItem>
                                                    <ListItem divider key={i + '-power'}>
                                                        <ListItemText>
                                                            <b>Max. Leistung</b>
                                                        </ListItemText>
                                                        <ListItemSecondaryAction>
                                                            {plug.type.max_power_string}
                                                        </ListItemSecondaryAction>
                                                    </ListItem>
                                                </React.Fragment>
                                            </Card>
                                        </Box>
                                    )
                                }) : null}
                            </List>
                        </div>
                    </div>
                    : null}
            </div>
        </Drawer>
    );
}

function renderStatusColor(status, group) {
    var statusColor = COLOR_FREE;

    switch (status) {
        case 'available':
            statusColor = COLOR_FREE;
            break;
        case 'occupied':
            statusColor = COLOR_OCCUPIED;
            break;
        case 'unavailable':
            statusColor = COLOR_FAILURE;
            break;
        case 'reserved':
            statusColor = COLOR_RESERVED;
            break;
        default:
            break;
    }

    if (group) {
        if (group !== null && group.indexOf('_offline') !== -1) {
            statusColor = COLOR_OCCUPIED;
        }
    }

    return statusColor;
}

function renderStatus(connectorStatus) {
    var status = 'N/A';

    if (connectorStatus === 'available') {
        status = 'Verfügbar';
    } else if (connectorStatus === 'occupied') {
        status = 'Belegt';
    } else if (connectorStatus === 'unavailable') {
        status = 'Kein Status';
    } else if (connectorStatus === 'unavailable') {
        status = 'Belegt';
    }

    return status;
}

const mapStateToProps = (state) => ({
    station: state.station,
    loadingStation: state.loading_station
})

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(DetailDrawer);